import {
  ClientSubclientServicepoint,
  Delegation,
  IClientSubclient,
  IClientSubclientData,
  IClientSubclientServicepoint,
  IDelegation,
  IThirdcode,
  Thirdcode,
} from "@/entities";

export class ClientSubclient implements IClientSubclient {
  readonly id?: number;
  readonly oidSol?: string;
  readonly codeSol?: string;
  readonly idSmartcash?: string;
  readonly uniqueCode?: string;
  readonly description?: string;
  readonly active?: boolean;
  readonly delegation?: IDelegation;
  readonly servicepoints?: IClientSubclientServicepoint[];
  readonly thirdcodes?: IThirdcode[];

  constructor(data: IClientSubclientData) {
    this.id = data.id;
    this.oidSol = data.oidSol;
    this.codeSol = data.codeSol;
    this.idSmartcash = data.idSmartcash;
    this.uniqueCode = data.uniqueCode;
    this.description = data.description;
    this.active = data.active;
    this.thirdcodes = data.thirdcodes?.map((thircode) => new Thirdcode(thircode));

    if (data.delegation) {
      this.delegation = new Delegation(data.delegation);
    }

    this.servicepoints = data.servicepoints?.map(
      (servicepoint) => new ClientSubclientServicepoint(servicepoint)
    );
  }
}
